/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Appointment } from './Appointment';
import {
    AppointmentFromJSON,
    AppointmentFromJSONTyped,
    AppointmentToJSON,
} from './Appointment';
import type { TaskComment } from './TaskComment';
import {
    TaskCommentFromJSON,
    TaskCommentFromJSONTyped,
    TaskCommentToJSON,
} from './TaskComment';

/**
 * 
 * @export
 * @interface PatientListItem
 */
export interface PatientListItem {
    /**
     * 
     * @type {string}
     * @memberof PatientListItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientListItem
     */
    tenant_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientListItem
     */
    patient_id: string;
    /**
     * 
     * @type {number}
     * @memberof PatientListItem
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientListItem
     */
    information?: string;
    /**
     * 
     * @type {Appointment}
     * @memberof PatientListItem
     */
    appointment?: Appointment;
    /**
     * 
     * @type {Array<TaskComment>}
     * @memberof PatientListItem
     */
    comments?: Array<TaskComment>;
    /**
     * Unix seconds. Set on join and on every patient confirmation. Unset => fall back to `date`.
     * @type {number}
     * @memberof PatientListItem
     */
    confirmed_at?: number;
    /**
     * Unix seconds. When the weekly re-confirmation ask was last sent. Unset => never asked.
     * @type {number}
     * @memberof PatientListItem
     */
    last_asked_at?: number;
    /**
     * Consecutive asks with no patient response, 0-2. Reset to 0 by any confirmation-equivalent act. >= STALE_THRESHOLD => stale, asking stops.
     * @type {number}
     * @memberof PatientListItem
     */
    unanswered_asks?: number;
    /**
     * Whether any notification channel was viable at the last ask. False => the patient cannot be reached electronically and needs a phone call. Unset => never evaluated.
     * @type {boolean}
     * @memberof PatientListItem
     */
    last_ask_deliverable?: boolean;
}

/**
 * Check if a given object implements the PatientListItem interface.
 */
export function instanceOfPatientListItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_id" in value;

    return isInstance;
}

export function PatientListItemFromJSON(json: any): PatientListItem {
    return PatientListItemFromJSONTyped(json, false);
}

export function PatientListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenant_id': !exists(json, 'tenant_id') ? undefined : json['tenant_id'],
        'patient_id': json['patient_id'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'information': !exists(json, 'information') ? undefined : json['information'],
        'appointment': !exists(json, 'appointment') ? undefined : AppointmentFromJSON(json['appointment']),
        'comments': !exists(json, 'comments') ? undefined : ((json['comments'] as Array<any>).map(TaskCommentFromJSON)),
        'confirmed_at': !exists(json, 'confirmed_at') ? undefined : json['confirmed_at'],
        'last_asked_at': !exists(json, 'last_asked_at') ? undefined : json['last_asked_at'],
        'unanswered_asks': !exists(json, 'unanswered_asks') ? undefined : json['unanswered_asks'],
        'last_ask_deliverable': !exists(json, 'last_ask_deliverable') ? undefined : json['last_ask_deliverable'],
    };
}

export function PatientListItemToJSON(value?: PatientListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenant_id': value.tenant_id,
        'patient_id': value.patient_id,
        'date': value.date,
        'information': value.information,
        'appointment': AppointmentToJSON(value.appointment),
        'comments': value.comments === undefined ? undefined : ((value.comments as Array<any>).map(TaskCommentToJSON)),
        'confirmed_at': value.confirmed_at,
        'last_asked_at': value.last_asked_at,
        'unanswered_asks': value.unanswered_asks,
        'last_ask_deliverable': value.last_ask_deliverable,
    };
}

